import { Action } from '@ngrx/store';


import * as models from '../../../../shared/model/api/models';

/**
 * SuperMenu Action Types
 */
export const HEADER_MENU_ACTION = {
  SET_ACTIVE: '[NAVIGATETAB] CLICKED',
  LOAD_WRITEUP_DETAIL: '[WriteupDetails] Initiate load for dealer detail',
  LOAD_WRITEUP_DETAIL_SUCCESS: '[WriteupDetails] dealer detail loaded Success',
  LOAD_WRITEUP_DETAIL_FAIL: '[WriteupDetails] dealer detail loaded Fail',
  CALCULATE_PRICE_ESTIMATE_ARRAY: '[WriteupDetails] Initiate load for payment rate term service',
  CALCULATE_PRICE_ESTIMATE_ARRAY_SUCCESS: '[WriteupDetails] payment rate term service success',
  CALCULATE_PRICE_ESTIMATE_ARRAY_FAIL: '[WriteupDetails] payment rate term service fail',
  GET_INCENTIVE_ARRAY: '[WriteupDetails] Initiate Incentive array service',
  GET_INCENTIVE_ARRAY_SUCCESS: '[WriteupDetails] Incentive array service pass',
  GET_INCENTIVE_ARRAY_FAIL: '[WriteupDetails] Incentive array service fail',
  WRITEUP_DETAIL_RESET: '[WriteupDetails] WriteUp detail reset',
  GET_IMAGE_VALUES: '[WriteupDetails] Get vehicle images value',
  GET_IMAGE_VALUES_SUCCESS: '[WriteupDetails] Get vehicle images value success',
  GET_IMAGE_VALUES_FAIL: '[WriteupDetails] Get vehicle images value fail',
  DELETE_TRADE_IN_ACTION: '[WriteupDetails] TO delete trade in',
  DELETE_TRADE_IN_SUCESS_ACTION: '[WriteupDetails] TO delete trade in success',
  DELETE_TRADE_IN_FAIL_ACTION: '[WriteupDetails] TO delete trade in fail',
  GET_FORMS_DETAILS_ACTION: '[WriteupDetails] To get forms details',
  GET_FORMS_DETAILS_SUCCESS_ACTION: '[WriteupDetails] To get forms details success',
  GET_FORMS_DETAILS_FAILURE_ACTION: '[WriteupDetails] To get forms details fail',
  OPEN_DIALOG: '[WriteupDetails] OPEN_DIALOG',
  OPEN__MESSAGE_PANEL: '[WriteupDetails] OPEN_MESSAGE_PANEL',
  CLOSE__MESSAGE_PANEL: '[WriteupDetails] CLOSE_MESSAGE_PANEL',
  CLOSE_DIALOG: '[WriteupDetails] CLOSE_DIALOG',
  SEND_DESK_DEAL:'[DealDetails] Send to Desk Deal',
  SEND_DESK_DEAL_SUCCESS:'[DealDetails] Send to Desk Deal Success',
  SEND_DESK_DEAL_FAIL:'[DealDetails] Send to Desk Deal Failure',
  SEND_DEAL_JACKET:'[DealDetails] Send  Deal Jacket',
  SEND_DEAL_JACKET_SUCCESS:'[DealDetails] Send Deal Jacket Success',
  SEND_DEAL_JACKET_FAIL:'[DealDetails] Send  Deal Jacket Failure',
  SEND_NEW_OFFER: '[DealDetails] Send new offer for deal',
  SEND_NEW_OFFER_SUCCESS: '[DealDetails] Send new offer for deal Success',
  SEND_NEW_OFFER_FAIL: '[DealDetails] Send new offer for deal Fail',
  SAVE_CHANGES: '[DealDetails] Save changes for deal',
  SAVE_CHANGES_SUCCESS: '[DealDetails] Save changes for deal Success',
  SAVE_CHANGES_FAIL: '[DealDetails] Save changes for deal Fail',
  CLONE_DEAL: '[DealDetails] Clone for deal',
  CLONE_SUCCESS: '[DealDetails] Clone for deal Success',
  CLONE_FAIL: '[DealDetails] Clone for deal Fail',
  PROTECTION_PRODUCTS: '[DealDetails] Protection Product Action',
  PROTECTION_PRODUCTS_SUCCESS: '[DealDetails] Protection Product Action Success',
  PROTECTION_PRODUCTS_FAIL: '[DealDetails] Protection Product Action Fail',
  UPDATE_WRITE_UP_VISITED: '[WriteupDetails] Update the status of write-up',
  UPDATE_WRITE_UP_VISITED_SUCCESS: '[WriteupDetails] Update the status of write-up success',
  UPDATE_WRITE_UP_VISITED_FAIL: '[WriteupDetails] Update the status of write-up failed',
  GET_TRADE_IN_VIN_ID_ACTION: '[WriteupDetails] To get the trade in value action',
  GET_TRADE_IN_VIN_ID_SUCESS_ACTION: '[WriteupDetails] To get the trade in value sucess action',
  GET_TRADE_IN_VIN_ID_FAIL_ACTION: '[WriteupDetails] To get the trade in value fail action',
  SEND_NEW_MESSAGE: '[DealDetails] Send new message for deal',
  SEND_NEW_MESSAGE_SUCCESS: '[DealDetails] Send new message success for deal',
  SEND_NEW_MESSAGE_FAIL: '[DealDetails] Send new message failed for deal',
  GET_ALL_MESSAGES: '[DealDetails] Get all messagaes for deal',
  GET_ALL_MESSAGES_SUCCESS: '[DealDetails] Get all messagaes success for deal',
  GET_ALL_MESSAGES_FAIL: '[DealDetails] Get all messagaes failed for deal',
  TRADE_PROCESS: '[DealDetails] Trade process for deal',
  TRADE_PROCESS_SUCCESS: '[DealDetails] Trade process for deal sucess',
  TRADE_PROCESS_FAIL: '[DealDetails] Trade process for deal fail',
  DFI_STATUS_ACTION: '[WriteupDetails] DFI_STATUS_ACTION',
  DFI_STATUS_ACTION_SUCCESS: '[WriteupDetails] DFI_STATUS_ACTION_SUCCESS',
  DFI_STATUS_ACTION_FAIL: '[WriteupDetails] DFI_STATUS_ACTION_FAIL',
  INVENTORY_VEHICLE_ACTION: '[WriteupDetails] INVENTORY_VEHICLE_ACTION',
  INVENTORY_VEHICLE_ACTION_SUCCESS: '[WriteupDetails] INVENTORY_VEHICLE_ACTION_SUCCESS',
  INVENTORY_VEHICLE_ACTION_FAIL: '[WriteupDetails] INVENTORY_VEHICLE_ACTION_FAIL',
  SERIES_VEHICLE_ACTION: '[SeriesDetails] SERIES_VEHICLE_ACTION',
  SERIES_VEHICLE_ACTION_SUCCESS: '[SeriesDetails]SERIES_VEHICLE_ACTION_SUCCESS',
  SERIES_VEHICLE_ACTION_FAIL: '[SeriesDetails] SERIES_VEHICLE_ACTION_FAIL',
  SEND_EMAIL_ACTION:'[WriteupDetails] send email with base64 data',
  WRITEUP_DETAIL_SPECURL_RESET: '[WriteupDetails] Reset spec URL',
  SEND_EMAIL_SUCCESS_ACTION: '[WriteupDetails] send email success with base64 data',
  SEND_EMAIL_FAIL_ACTION: '[WriteupDetails] send email fail with base64 data',
  SEND_SMS_ACTION:'[WriteupDetails] send sms',
  SEND_SMS_SUCCESS_ACTION: '[WriteupDetails] send sms successfully',
  SEND_SMS_FAIL_ACTION: '[WriteupDetails] send sms fail',
  LOAD_INVENTORY:'[Inventory] load inventory',
  LOAD_INVENTORY_SUCCESS_ACTION: '[Inventory] load inventory successfully',
  LOAD_INVENTORY_FAIL_ACTION: '[Inventory] load inventory failure',  
  LOAD_ADDRESS:'[Address] load Address',
  LOAD_ADDRESS_SUCCESS_ACTION: '[Address] load Address successfully',
  LOAD_ADDRESS_FAIL_ACTION: '[Address] load Address failure',
  SEARCH_CUSTOMER:'[Customer] Search Cutomer',
  SEARCH_CUSTOMER_SUCCESS_ACTION: '[Customer] Search Cutomer successfully',
  SEARCH_CUSTOMER_FAIL_ACTION: '[Customer] Search Cutomer failure',
  ADD_COBUYER:'[Cobuyer] Add Cobuyer',
  ADD_COBUYER_SUCCESS_ACTION: '[Cobuyer] Add Cobuyer successfully',
  ADD_COBUYER_FAIL_ACTION: '[Cobuyer] Add Cobuyer failure',
  REMOVE_COBUYER:'[Cobuyer] Remove Cobuyer',
  REMOVE_COBUYER_SUCCESS_ACTION: '[Cobuyer] Remove Cobuyer successfully',
  REMOVE_COBUYER_FAIL_ACTION: '[Cobuyer] Remove Cobuyer failure',
  RETRIEVE_CUSTOMER:'[CustomerData] get Cutomer data',
  RETRIEVE_CUSTOMER_SUCCESS_ACTION: '[CustomerData] get Cutomer data successfully',
  RETRIEVE_CUSTOMER_FAIL_ACTION: '[CustomerData] get Cutomer data failure',    
  GET_VSPEC_ACTION:'[vspec] get vspec shortend url',
  GET_VSPEC_SUCCESS_ACTION: '[vspec] get vspec shortend url successfully',
  GET_VSPEC_FAIL_ACTION: '[vspec] get vspec shortend url fail',
  CALCULATE_PRICE_ESTIMATE_PDF_ARRAY: '[WriteupDetails] CALCULATE_PRICE_ESTIMATE_PDF_ARRAY',
  CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_SUCCESS: '[WriteupDetails] CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_SUCCESS',
  CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_FAIL: '[WriteupDetails] CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_FAIL',
  CALCULATE_PRICE_ESTIMATE_RESET: '[WriteupDetails] CALCULATE_PRICE_ESTIMATE_RESET',
  CONTRACT_APPROVED: '[DealDetails] Contract approved for deal',
  CONTRACT_APPROVED_SUCCESS: '[DealDetails] Contract approved for deal Success',
  CONTRACT_APPROVED_FAIL: '[DealDetails] Contract approved for deal Fail',
  SEND_TO_TRANSACTION: '[DealDetails] send to transaction for deal',
  SEND_TO_TRANSACTION_SUCCESS: '[DealDetails] send to transaction for deal Success',
  SEND_TO_TRANSACTION_FAIL: '[DealDetails] send to transaction for deal Fail',
  ADD_TOYOTA_ACCESSORIES: '[DealDetails] Add Toyota Accessories ',
  ADD_TOYOTA_ACCESSORIES_SUCCESS: '[DealDetails] Add Toyota accessories  Success',
  ADD_TOYOTA_ACCESSORIES_FAIL: '[DealDetails] Add Toyota accessories Fail',
  ADD_DEALER_ACCESSORIES: '[DealDetails] Add Dealer Accessories ',
  ADD_DEALER_ACCESSORIES_SUCCESS: '[DealDetails] Add Dealer accessories  Success',
  ADD_DEALER_ACCESSORIES_FAIL: '[DealDetails] Add Dealer accessories Fail',
  RESET_EMAILTRANSACTION_ACTION:'[DealDetails] RESET_EMAILTRANSACTION_ACTION',
  RESET_SEND_TRANSACTION_ACTION:'[DealDetails] RESET_SEND_TRANSACTION_ACTION',
  COPY_COBUYER_TRADE:'[Trade Right Panel] COPY_CLICKED',
  COPY_COBUYER_TRADE_SUCCESS_ACTION:'[Trade Right Panel] COPY_TRADE_CLICKED_SUCCESS',
  COPY_COBUYER_TRADE_FAIL_ACTION:'[Trade Right Panel] COPY_TRADE_CLICKED_FAIL',
  VIN_DECODE_ACTION:'[Trade Right Panel] VIN Decode',
  VIN_DECODE_SUCCESS_ACTION:'[Trade Right Panel] VIN Decode success',
  VIN_DECODE_FAIL_ACTION:'[Trade Right Panel] VIN Decode fail',
  PLATE_TRANSFER_ACTION:'[Trade Right Panel] Plate Transfer UI Status',
  PLATE_TRANSFER_SUCCESS_ACTION:'[Trade Right Panel] Plate Transfer UI Status success',
  PLATE_TRANSFER_FAIL_ACTION:'[Trade Right Panel] Plate Transfer UI Status fail',
};

export enum HeaderMenuItem {
  Finance = 0,
  Lease = 1,
  Cash = 2,
  Zero=3,
  First=4,
  OnePay=5,
  SignAndDrive=6
}
/**
 * Super Menu Clicked
 */
export class HeaderMenuSetActive implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SET_ACTIVE;
  constructor(public payload?: any) { }
}

/**
 * Method used to load the dealer detail 
 */
export class WriteUpDetailsAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_WRITEUP_DETAIL;
  constructor(public payload?: string, public value?:string) { }
}

/**
 * Method used to handle the Success action for dealer detail load
 */
export class WriteUpDetailsSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_WRITEUP_DETAIL_SUCCESS;
  constructor(public payload: models.DealDetails) { }
}

/**
 * Method used to handle the Failure action for dealer detail load
 */
export class WriteUpDetailsFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_WRITEUP_DETAIL_FAIL;
  constructor(public payload: any) { }
}

/**
 * Method used to Calculate Price Estimate Array
 */
export class CalculatePriceEstimateArrayAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_ARRAY;
  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Calculate Price Estimate Array Success method
 */
export class CalculatePriceEstimateArraySuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_ARRAY_SUCCESS;
  constructor(public payload: any) { }
}

/**
 * Method used to handle the Failure action for Calculate Price Estimate Array Fail method
 */
export class CalculatePriceEstimateArrayFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_ARRAY_FAIL;
  constructor(public payload: string) { }
}

/**
 * Method used to Calculate Price Estimate Array
 */
export class GetIncentiveArrayAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_INCENTIVE_ARRAY;
  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Calculate Price Estimate Array Success method
 */
export class GetIncentiveArraySuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_INCENTIVE_ARRAY_SUCCESS;
  constructor(public payload: {}) { }
}

/**
 * Method used to handle the Failure action for Calculate Price Estimate Array Fail method
 */
export class GetIncentiveArrayFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_INCENTIVE_ARRAY_FAIL;
  constructor(public payload: string) { }
}

export class WritupsDetailGetVehicleImagesAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_IMAGE_VALUES;
  constructor(public payload?: any) { }
}

export class WritupsDetailGetVehicleImagesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_IMAGE_VALUES_SUCCESS;
  constructor(public payload?: any) { }
}

export class WritupsDetailGetVehicleImagesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_IMAGE_VALUES_FAIL;
  constructor(public payload?: any) { }
}


/**
 * Method used for service call to delete tradeIn
 */

export class DeleteTradeAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DELETE_TRADE_IN_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to delete tradeIn
*/
export class DeleteTradeSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DELETE_TRADE_IN_SUCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to delete tradeIn
 */

export class DeleteTradeSuccessFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DELETE_TRADE_IN_FAIL_ACTION;
  constructor(public payload?: any) { }
}




/**
 * Method used for service call to get form Details
 */

export class FormsDetailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_FORMS_DETAILS_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to get form Details success
*/
export class FormsDetailSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_FORMS_DETAILS_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Details fail
 */

export class FormsDetailFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_FORMS_DETAILS_FAILURE_ACTION;
  constructor(public payload?: any) { }
}



/**
 * Method used to Reset the dealer detail 
 */
export class WriteUpDetailsResetAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.WRITEUP_DETAIL_RESET;
  constructor() { }
}

/**
 * WriteUpOpenDialog
 */
export class WriteupDetailOpenDialog implements Action {
  public readonly type: string = HEADER_MENU_ACTION.OPEN_DIALOG;
  constructor(public payload?: any) {
  }
}

/**
 * OpenMessagePanel
 */
export class WriteupDetailOpenMessagePanel implements Action {
  public readonly type: string = HEADER_MENU_ACTION.OPEN__MESSAGE_PANEL;
  constructor(public payload: any) {
  }
}
/**
 * CloseMessagePanel
 */
export class WriteupDetailCloseMessagePanel implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CLOSE__MESSAGE_PANEL;
  constructor(public payload: any) {
  }
}


export class WriteupDetailCloseDialog implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CLOSE_DIALOG;
  constructor() { }
}



/**
* Method used to Send Desk Deal
*/
export class SendDeskDealAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DESK_DEAL;

  constructor(public payload: any) { }
}
/**
 * Method used to handle the Success action for send desk deal Success method
 */
 export class SendDeskDealSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DESK_DEAL_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action forsend desk deal fail method
 */
export class SendDeskDealFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DESK_DEAL_FAIL;

  constructor(public payload: any) { }
}

export class SendDealJacketAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DEAL_JACKET;

  constructor(public payload: any) { }
}
export class SendDealJacketSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DEAL_JACKET_SUCCESS;

  constructor(public payload: any) { }
}
export class SendDealJacketFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_DEAL_JACKET_FAIL;

  constructor(public payload: any) { }
}
/**
* Method used to Send New Offer
*/
export class SendNewOfferAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_OFFER;

  constructor(public payload: any) { }
}


/**
 * Method used to handle the Success action for Send New Offer Success method
 */
export class SendNewOfferSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_OFFER_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action for Send New Offer fail method
 */
export class SendNewOfferFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_OFFER_FAIL;

  constructor(public payload: any) { }
}
/**
* Method used to save changes
*/
export class SaveChangesAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SAVE_CHANGES;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for save changes Success method
 */
export class SaveChangesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SAVE_CHANGES_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action for save changes fail method
 */
export class SaveChangesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SAVE_CHANGES_FAIL;

  constructor(public payload: any) { }
}
/**
* Method used to Clone
*/
export class CloneAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CLONE_DEAL;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for clone Success method
 */
export class CloneSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CLONE_SUCCESS;

  constructor(public payload?: any) { }
}
/**
 * Method used to handle the Fail action for clone fail method
 */
export class CloneFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CLONE_FAIL;

  constructor(public payload: any) { }
}
/**
* Method used to protection product update
*/
export class ProtectionProductAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PROTECTION_PRODUCTS;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Send New Offer Success method
 */
export class ProtectionProductSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PROTECTION_PRODUCTS_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action for Send New Offer fail method
 */
export class ProtectionProductFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PROTECTION_PRODUCTS_FAIL;

  constructor(public payload: any) { }
}



/**
* Method used to Send New Message
*/
export class SendNewMessageAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_MESSAGE;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Send New Message Success method
 */
export class SendNewMessageSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_MESSAGE_SUCCESS;

  constructor(public payload: any) { }
}
/**
 * Method used to handle the Fail action for Send New Message Success method
 */
export class SendNewMessageFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_NEW_MESSAGE_FAIL;

  constructor(public payload: any) { }
}


/**
* Method used to get all messgaes
*/
export class GetAllMessagesAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_ALL_MESSAGES;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for get all messgaes
 */
export class GetAllMessagesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_ALL_MESSAGES_SUCCESS;

  constructor(public payload: any) { }
}
/**
 * Method used to handle the Fail action for get all messgaes
 */
export class GetAllMessagesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_ALL_MESSAGES_FAIL;

  constructor(public payload: any) { }
}


/**
* Method used to update visisted status of write-up
*/
export class UpdateStatusAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.UPDATE_WRITE_UP_VISITED;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for update visisted status of write-up
 */
export class UpdateStatusSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.UPDATE_WRITE_UP_VISITED_SUCCESS;

  constructor(public payload: any) { }
}


/**
 * Method used to handle the fail action for update visisted status of write-up
 */
export class UpdateStatusFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.UPDATE_WRITE_UP_VISITED_FAIL;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the fail action for update visisted status of write-up
 */
export class GetTradeinVinidAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_TRADE_IN_VIN_ID_ACTION;

  constructor(public payload: any) { }
}


/*
* Method used for service call in tradein
*/
export class GetTradeinVinidSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_TRADE_IN_VIN_ID_SUCESS_ACTION;

  constructor(public payload: any) { console.log(" GetTradeinVinidSuccessAction :) ") };
}
/*
* Method used for service call in tradein
*/
export class GetTradeinVinidSuccessFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_TRADE_IN_VIN_ID_FAIL_ACTION;

  constructor(public payload: any) { };
}

/**
* Method used to Trade Process
*/
export class TradeProcessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.TRADE_PROCESS;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Trade Process success method
 */
export class TradeProcessSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.TRADE_PROCESS_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action for Trade Process fail method
 */
export class TradeProcessFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.TRADE_PROCESS_FAIL;

  constructor(public payload: any) { }
}

export class DfiStatusAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DFI_STATUS_ACTION;
  constructor(public payload: string) {}
}
export class DfiStatusActionSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DFI_STATUS_ACTION_SUCCESS;
  constructor(public payload: any) {}
}
export class DfiStatusActionFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.DFI_STATUS_ACTION_FAIL;
  constructor(public payload: any) {}
}

export class InventoryVehicleAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.INVENTORY_VEHICLE_ACTION;
  constructor(public payload: models.DealRoute) {}
}

export class InventoryVehicleSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.INVENTORY_VEHICLE_ACTION_SUCCESS;
  constructor(public payload: any) {}
}

export class InventoryVehicleFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.INVENTORY_VEHICLE_ACTION_FAIL;
  constructor(public payload: any) {}
}
export class SeriesVehicleAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SERIES_VEHICLE_ACTION;
  constructor(public payload: models.DealRoute) {}
}

export class SeriesVehicleSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SERIES_VEHICLE_ACTION_SUCCESS;
  constructor(public payload: any) {}
}

export class SeriesVehicleFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SERIES_VEHICLE_ACTION_FAIL;
  constructor(public payload: any) {}
}
export class SendEmailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_EMAIL_ACTION;;
  constructor(public payload?: any) { }
}
export class WriteUpDetailsSpecURLResetAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.WRITEUP_DETAIL_SPECURL_RESET;;
  constructor() { }
}

/**
* Method used for service call to get form Details success
*/
export class SendEmailActionSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_EMAIL_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Details fail
 */

export class SendEmailActionFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_EMAIL_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class GetVspecUrlAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_VSPEC_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to get form Details success
*/
export class GetVspecUrlActionSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_VSPEC_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Details fail
 */

export class GetVspecUrlActionFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.GET_VSPEC_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class SendSMSAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_SMS_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to get form Details success
*/
export class SendSMSActionSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_SMS_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Details fail
 */

export class SendSMSActionFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_SMS_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class LoadInventory implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_INVENTORY;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to get form Details success
*/
export class LoadInventorySuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_INVENTORY_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Details fail
 */

export class LoadInventoryFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_INVENTORY_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class LoadAddress implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_ADDRESS;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to get form Adress success
*/
export class LoadAddressSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_ADDRESS_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Method used for service call to get form Adress fail
 */

export class LoadAddressFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.LOAD_ADDRESS_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class SearchCustomer implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEARCH_CUSTOMER;
  constructor(public payload?: any) { }
}
export class SearchCustomerSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEARCH_CUSTOMER_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}
export class SearchCustomerFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEARCH_CUSTOMER_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class AddCobuyer implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_COBUYER;
  constructor(public payload?: any) { }
}
export class AddCobuyerSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_COBUYER_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}
export class AddCobuyerFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_COBUYER_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class removeCobuyer implements Action {
  public readonly type: string = HEADER_MENU_ACTION.REMOVE_COBUYER;
  constructor(public payload?: any) { }
}
export class removeCobuyerSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.REMOVE_COBUYER_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}
export class removeCobuyerFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.REMOVE_COBUYER_FAIL_ACTION;
  constructor(public payload?: any) { }
}
export class RetrieveCustomer implements Action {
  public readonly type: string = HEADER_MENU_ACTION.RETRIEVE_CUSTOMER;
  constructor(public payload?: any) { }
}
export class RetrieveCustomerSuccess implements Action {
  public readonly type: string = HEADER_MENU_ACTION.RETRIEVE_CUSTOMER_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}
export class RetrieveCustomerFail implements Action {
  public readonly type: string = HEADER_MENU_ACTION.RETRIEVE_CUSTOMER_FAIL_ACTION;
  constructor(public payload?: any) { }
}
/**
 * Method used to Calculate Price Estimate pdf Array
 */
export class CalculatePriceEstimatePdfArrayAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_PDF_ARRAY;
  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Calculate Price Estimate pdf Array Success method
 */
export class CalculatePriceEstimatePdfArraySuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_SUCCESS;
  constructor(public payload: any) { }
}

/**
 * Method used to handle the Failure action for Calculate Price Estimate pdf Array Fail method
 */
export class CalculatePriceEstimatePdfArrayFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_PDF_ARRAY_FAIL;
  constructor(public payload: string) { }
}

/**
 * Method used to Reset the Calculate data pdf reset
 */
export class CalculatePriceEstimateResetAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CALCULATE_PRICE_ESTIMATE_RESET;
  constructor() { }
}

/**
* Method used to Contract Approved
*/
export class ContractApprovedAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CONTRACT_APPROVED;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Contract Approved Success method
 */
export class ContractApprovedSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CONTRACT_APPROVED_SUCCESS;

  constructor(public payload: models.DealDetails) { }
}
/**
 * Method used to handle the Fail action for Contract Approved fail method
 */
export class ContractApprovedFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.CONTRACT_APPROVED_FAIL;

  constructor(public payload: any) { }
}
export class SendToTransactionAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_TO_TRANSACTION;

  constructor(public payload: any) { }
}
export class SendToTransactionSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_TO_TRANSACTION_SUCCESS;

  constructor(public payload: any) { }
}
export class SendToTransactionFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.SEND_TO_TRANSACTION_FAIL;

  constructor(public payload: any) { }
}

/**
* Method used to Add Accessories
*/
export class AddToyotaAccessoriesAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_TOYOTA_ACCESSORIES;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for  accessories
 */
export class AddToyotaAccessoriesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_TOYOTA_ACCESSORIES_SUCCESS;

  constructor(public payload: any) { }
}
/**
 * Method used to handle the Fail action for accessories
 */
export class AddToyotaAccessoriesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_TOYOTA_ACCESSORIES_FAIL;

  constructor(public payload: any) { }
}

export class AddDealerAccessoriesAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_DEALER_ACCESSORIES;

  constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for  accessories
 */
export class AddDealerAccessoriesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_DEALER_ACCESSORIES_SUCCESS;

  constructor(public payload: any) { }
}
/**
 * Method used to handle the Fail action for accessories
 */
export class AddDealerAccessoriesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.ADD_DEALER_ACCESSORIES_FAIL;

  constructor(public payload: any) { }
}
export class ResetEmailTransactionAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.RESET_EMAILTRANSACTION_ACTION;

  constructor(public payload: any) { }
}
export class ResetSendTransactionAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.RESET_SEND_TRANSACTION_ACTION;

  constructor(public payload: any) { }
}


export class CopyCobuyerTrades implements Action {
  public readonly type: string = HEADER_MENU_ACTION.COPY_COBUYER_TRADE;
  constructor(public payload: models.DealDetails) { }
}
export class CopyCobuyerTradesSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.COPY_COBUYER_TRADE_SUCCESS_ACTION;
  constructor(public payload: models.DealDetails) { }
}
export class CopyCobuyerTradesFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.COPY_COBUYER_TRADE_FAIL_ACTION;
  constructor(public payload?: any) {}
}

/**
 * Method used for service call to VIN decode
 */

export class VINDecodeAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.VIN_DECODE_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to VIN decode success
*/
export class VINDecodeSuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.VIN_DECODE_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to VIN decode failure
 */

export class VINDecodeFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.VIN_DECODE_FAIL_ACTION;
  constructor(public payload?: any) { }
}

export class getPlateTransferUIAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PLATE_TRANSFER_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to plate transfer success
*/
export class getPlateTransferUISuccessAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PLATE_TRANSFER_SUCCESS_ACTION;
  constructor(public payload?: any) { }
}

/**
* Method used for service call to plate transfer failure
 */

export class getPlateTransferUIFailAction implements Action {
  public readonly type: string = HEADER_MENU_ACTION.PLATE_TRANSFER_FAIL_ACTION;
  constructor(public payload?: any) { }
}

/**
 * Export a type alias of all ActionsType in this action group
 * so that reducers can easily compose action types
 */
export type ActionsType =
  HeaderMenuSetActive
  | WriteUpDetailsAction | WriteUpDetailsSuccessAction | WriteUpDetailsFailAction
  | CalculatePriceEstimateArrayAction | CalculatePriceEstimateArraySuccessAction | CalculatePriceEstimateArrayFailAction
  | GetIncentiveArrayAction | GetIncentiveArraySuccessAction | GetIncentiveArrayFailAction | WriteUpDetailsResetAction
  | WritupsDetailGetVehicleImagesAction
  | WritupsDetailGetVehicleImagesSuccessAction
  | WritupsDetailGetVehicleImagesFailAction
  | DeleteTradeAction | DeleteTradeSuccessAction | DeleteTradeSuccessFail | FormsDetailFailAction | FormsDetailSuccessAction | FormsDetailAction
  | WriteupDetailOpenDialog | WriteupDetailCloseDialog | SendNewOfferAction | SendNewOfferSuccessAction | SendNewOfferFailAction | UpdateStatusSuccessAction | UpdateStatusFailAction | UpdateStatusAction
  | GetTradeinVinidAction | GetTradeinVinidSuccessAction | GetTradeinVinidSuccessFail | WriteupDetailOpenMessagePanel | WriteupDetailCloseMessagePanel | SendNewMessageAction | SendNewMessageSuccessAction | SendNewMessageFailAction
  | GetAllMessagesAction |GetAllMessagesSuccessAction |GetAllMessagesFailAction | TradeProcessAction | TradeProcessSuccessAction | TradeProcessFailAction
  | DfiStatusAction | DfiStatusActionSuccess | DfiStatusActionFail | InventoryVehicleAction | InventoryVehicleSuccessAction | InventoryVehicleFailAction |SeriesVehicleAction| SeriesVehicleSuccessAction | SeriesVehicleFailAction 
  | DfiStatusAction | DfiStatusActionSuccess | DfiStatusActionFail | SendEmailAction | SendEmailActionSuccess | SendEmailActionFail | SendSMSAction | SendSMSActionSuccess | SendSMSActionFail | LoadInventory| LoadInventorySuccess| LoadInventoryFail| LoadAddress | LoadAddressSuccess|LoadAddressFail| SearchCustomer|SearchCustomerSuccess|SearchCustomerFail| GetVspecUrlAction | GetVspecUrlActionSuccess
  | GetVspecUrlActionFail | CalculatePriceEstimatePdfArrayAction | CalculatePriceEstimatePdfArraySuccessAction | CalculatePriceEstimatePdfArrayFailAction | CalculatePriceEstimateResetAction |RetrieveCustomer|RetrieveCustomerSuccess|RetrieveCustomerFail | AddCobuyer| AddCobuyerSuccess | AddCobuyerFail |removeCobuyer |removeCobuyerSuccess|removeCobuyerFail
  | ProtectionProductAction | ProtectionProductSuccessAction | ProtectionProductFailAction
  | ContractApprovedAction | ContractApprovedSuccessAction | ContractApprovedFailAction | AddToyotaAccessoriesAction | AddToyotaAccessoriesSuccessAction | AddToyotaAccessoriesFailAction
  | AddDealerAccessoriesAction | AddDealerAccessoriesSuccessAction | AddDealerAccessoriesFailAction| ResetEmailTransactionAction|SendToTransactionAction|SendToTransactionSuccessAction|SendToTransactionFailAction|ResetSendTransactionAction | SaveChangesAction | SaveChangesSuccessAction | SaveChangesFailAction | CloneAction | CloneSuccessAction | CloneFailAction |
  CopyCobuyerTrades|CopyCobuyerTradesSuccessAction|CopyCobuyerTradesFailAction | VINDecodeAction | VINDecodeSuccessAction | VINDecodeFailAction |getPlateTransferUIAction |
  getPlateTransferUISuccessAction | getPlateTransferUIFailAction;

